import React from 'react';
import {Helmet} from "react-helmet";
import { Box, Container } from '@mui/material';
//import logo from '../../assets/images/logo_new.png';
//import arrow_down from "../../assets/images/arrow-down-01.png"
import academy from "./assets/rentacad.svg";
//import rend_id from "../../assets/images/rend_id.png";
//import rend_id2 from "../../assets/images/yellowglow.png";
//import { Link } from 'react-router-dom';
import Rentacademyanimation from './Rentacademyanimation';
//import RentHeader from '../RentHeader/RentHeader';
import RentAcademyPage from './RentAcademyPage/RentAcademyPage';
// import MoreSolutions from '../Rentid2/MoreSolutions/MoreSolutions';
// import PopularTopics from '../Rentid2/PopularTopics/PopularTopics';
import MoreSolutionsAcademy from './MoreSolutionsAcademy/MoreSolutionsAcademy';
import Footer from '../Footer/Footer';
import BetaForm from '../BetaForm';
const RentAcademy2 = () => {

  return (
    <>
      <Helmet>
        <title>RentAcademy | Master the Art of Vehicle Rental</title>
        <meta name="twitter:title" content="Rent Academy | Master the Art of Vehicle Rental" />
        <meta name="description" content="Unlock your potential in the vehicle rental industry with Rent Academy. Access exclusive resources, tutorials, and insights from industry leaders, national events, video libraries, and more. Learn, grow, and succeed on your own schedule." />
        <meta name="twitter:description" content="Join Rent Academy to access expert-led training, exclusive resources, and industry insights designed for vehicle rental entrepreneurs. Learn and grow at your own pace." />
        <meta property="og:description" content="Empowering vehicle rental operators with real-world knowledge, Rent Academy offers expert-led content, video tutorials, national events, and networking opportunities. Learn at your pace and elevate your business." />
        <meta name="keywords" content="Rent Academy, Vehicle Rental Training, Car Rental Education, Industry Insights, Rentid Video Library, National Events, Affiliate Program, Mobility Innovators, Vehicle Rental Entrepreneurs, Rental Tutorials" />
        <meta property="og:url" content="https://www.rentid.io/rentacademy" />
        <link rel="canonical" href="https://www.rentid.io/rentacademy" />
      </Helmet>
         <Box
          sx={{
            background: 'linear-gradient(180deg, #082C72 0%, #001132 55%, #000000 100%)',
            height: '',
            display:'none',
            width: '100%',
          }}
        >
        <Container>
         {/* <RentHeader/> */}


        {/* Banner section start from here */}

        <section className='bannerRentAcademyMain'>
            <div className="row">
                <div className='col-lg-5'>
                    <div className='bannerAcademyLeft'>
                        <img alt="Rent Academy" src={academy}></img>
                        <small>RENTAL BEST PRACTICES FOR GROWTH</small>
                        <h1>Learn on your time,<span className="uper-span">not your</span> <span>dime.</span></h1>
                        <p>Leverage our platform to educate yourself, inform your guests, and train your staff for healthier operations.</p>
                    </div>
                </div>

                <div className='col-lg-7'>
                    <div className='bannerAcademyRight'>
                        {/* <img src={rend_id2} alt=''/> */}
                        <Rentacademyanimation />
                    </div>
                </div>
            </div>
        </section>
        
        </Container>
      </Box>
      <RentAcademyPage/>
      <MoreSolutionsAcademy/>
      {/* <PopularTopics/>  */}
      <Footer/>
      <BetaForm/>
    </>
  )
}

export default RentAcademy2
